import "es6-shim";
import "whatwg-fetch";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
import "font-awesome/css/font-awesome.css";

import Symbol from "es-symbol";

import React from "react";
import ReactDOM from "react-dom";

import $ from "jquery";

import "../node_modules/react-dropzone-component/styles/filepicker.css";
import "../node_modules/dropzone/dist/min/dropzone.min.css";
import "./index.scss";

import { showAuthOnDemand } from "./onDemand/Authentication/Authentication";
import { Dashboard } from "./onDemand/Dashboard/Dashboard";
import { UploadPj } from "./onDemand/Upload/UploadPj";
import Trajets from "./onDemand/Trajets/Trajets";

import { Header } from "./onDemand/Header/Header";
import { Footer } from "./onDemand/Footer/Footer";

if (!window.Symbol) {
  window.Symbol = Symbol;
}
window.$ = $;
window.jQuery = $;

/* -------------- */
/*     HEADER     */
/* -------------- */
export function header(node, opts) {
  ReactDOM.render(<Header {...opts} />, node);
}

/* --------------- */
/*  ESPACE-CLIENT  */
/* --------------- */
export function adminLoginOnDemand(node, opts) {
  showAuthOnDemand(node, opts);
}

export function dashboard(node, opts) {
  ReactDOM.render(<Dashboard {...opts} />, node);
}

export function uploadPJ(node, opts) {
  ReactDOM.render(<UploadPj {...opts} />, node);
}

export function trajets(node, opts) {
  ReactDOM.render(<Trajets {...opts} />, node);
}
/* -------------- */
/*     FOOTER     */
/* -------------- */
export function footer(node, opts) {
  ReactDOM.render(<Footer {...opts} />, node);
}
